export { default as EN } from "./en.json";
export const DEPLOYMENTS_NAMESPACE = "deployments";
